<div class="mech-diag-content">
	<app-raw-select [asset]="asset" [fleet]="fleet" [component]="component" [shaft]="shaft" (rawSelected)="rawSelected($event)"></app-raw-select>
	@if (selectedraw) {
	<div class="detail-panel">
		@if (component.type === 'tach') {
		<app-tach-detail [asset]="asset" [component]="component" [raw]="selectedraw"></app-tach-detail>
		}
		@if (component.type === 'shaft') {
		<app-shaft-detail [asset]="asset" [component]="component" [raw]="selectedraw"></app-shaft-detail>
		}
		@if (component.type === 'gear') {
		<app-gear-detail [asset]="asset" [component]="component" [shaft]="shaft" [raw]="selectedraw"></app-gear-detail>
		}
		@if (component.type === 'bearing') {
		<app-bearing-detail [asset]="asset" [component]="component" [shaft]="shaft" [raw]="selectedraw"></app-bearing-detail>
		}
		@if (component.type === 'sensor') {
		<app-sensor-detail [asset]="asset" [component]="component" [raw]="selectedraw"></app-sensor-detail>
		}
	</div>
	}
</div>